module.exports = __webpack_public_path__ + "static/media/enterpriseDetailsGrey.e836e2c8.svg";